module.exports = __webpack_public_path__ + "img/logo-spotify.33a1d12d.svg";